import React from "react";
import { useSteps } from "../useSteps";

export const DropStoreModeBadge = () => {
  const { dropStoreMode } = useSteps();

  return (
    <div
      className={`flex items-center justify-center px-3 py-1 rounded-full border ${
        dropStoreMode
          ? "bg-[#17E0C2] border-[#17E0C2]"
          : "bg-[#282F44] border-[#3A4159]"
      }`}
    >
      <span
        className={`text-xs font-semibold tracking-wider whitespace-nowrap ${
          dropStoreMode ? "text-[#060E23]" : "text-[#A1A7C2]"
        }`}
      >
        {dropStoreMode ? "DROP STORE MODE" : "MAIL IN MODE"}
      </span>
    </div>
  );
};
